// types.js
const SET_CURRENT_USER = 'user/current/set';
const SET_CHECKLIST = 'user/checklist/set';

export default {
  SET_CURRENT_USER,
  SET_CHECKLIST,
}